<template>
  <div id="app">
    <TopBanner />
    <div class="safe-area app-container"><router-view/></div>
    <BottomFooter />
  </div>
</template>

<script>
import TopBanner from './components/TopBanner'
import BottomFooter from './components/BottomFooter'

export default {
  name: 'App',
  components: {
    TopBanner,
    BottomFooter
  }
}
</script>

<style>
:root {
  --gap-size: 15px;
  --text-color: #222;
  --content-text-font-size: 14px;
}

body {
  padding: 0;
  margin: 0;
  /* position: relative; */
  background-color: #f1f1f1;
  font-family: sans-serif;
  overflow-y: scroll;
  font-size: var(--content-text-font-size);
}
</style>

<style lang="less" src="./base.less" />
<style lang="less" scoped>
.app-container {
  min-height: calc(100vh - 249px);
  padding: 10px;
}
</style>


// WEBPACK FOOTER //
// src/App.vue